<template>
  <div @click="openOtherScreen" class="customer-screen">
    <vs-table v-show="cartEntries && cartEntries.length > 0" :data="cartEntries"
      :class="{ 'blink-animation': shouldBlink }">
      <template id="tableThead" slot="thead">
        <vs-th class="w-6/12 border-bottom">
          <p class="text-primary text-small bold">Ürün</p>
        </vs-th>
        <vs-th class="w-1/12 border-bottom">
          <p class="text-primary text-small bold">Adet</p>
        </vs-th>
        <vs-th class="w-4/12 border-bottom">
          <p class="text-primary text-small bold">Fiyat(₺)</p>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody v-if="cartEntries.length > 0">
          <vs-tr :data="item" :key="index" v-for="(item, index) in cartEntries" class="align-center">
            <vs-td class="w-6/12">
              <p class="weight-600 truncate text-primary">{{ item.productName }}</p>
              <span v-for="(extra,eindex) in item.extras" :key="'extra'+eindex">
                <p class="product-extra text-primary" v-if="extra.quantity > 0 && (extra.variants.length == 0)">
                  x{{extra.quantity}} | {{extra.name}}
                </p>
                <span style="display:block;" class="product-extra text-primary" v-else-if="(extra.variants.length > 0)"
                  v-for="seletedVariantExtra in returnSelectedExtraVariant(extra)" :key="seletedVariantExtra">
                  {{seletedVariantExtra}}
                </span>
              </span>
              <span v-for="(step,rindex) in item.recipe.steps" :key="'step'+rindex">
                <p class="product-extra text-primary"
                  v-if="step.originRawMaterialId != null && (step.selected != null && step.selected) && !step.isRemoved">
                  {{step.mobileName != null ? step.mobileName : step.name}}
                </p>
              </span>
            </vs-td>
            <vs-td class="w-1/12">
              <p class="weight-600">{{ item.quantity }}</p>
            </vs-td>
            <vs-td class="w-4/12">
              <p class="weight-600">{{ $toCurrency(item.price) }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>




    </vs-table>
    <div id="basket-actions"
        v-if="cartEntries && (cartEntries.length > 0)" class="w-full p-5">
        <vs-row vs-type="flex" vs-w="12" style="height:100%;">
          <vs-col vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end">
                <vs-col vs-type="flex" vs-w="6" vs-justify="center" vs-align="center"
                  v-if="cartEntries.length">
                  <p class="label">Toplam :</p>
                  <p class="ml-2 price text-primary">{{$toCurrency(cartEntries.reduce((sum, item) => sum + item.price, 0))}}</p>
                </vs-col>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    <div v-if="!cartEntries || cartEntries.length == 0"
     class="customer-screen flex items-center justify-center min-h-screen">
  <img src="/img/brew.png" class="max-w-md w-auto h-auto">
</div>
  </div>

</template>

<script>
export default {
  name: 'CustomerScreen',

  data() {
    return {
      cartEntries: [],
      broadcaster: null,
      shouldBlink: false
    }
  },

  async created() {

    document.title= 'Lütfen ekranda herhangi bir yere tıklayınız...'
    // Broadcast kanalına bağlan
    this.broadcaster = new BroadcastChannel('cart-channel');

    // Mesajları dinle
    this.broadcaster.onmessage = (event) => {
      if (event.data.type === 'CART_UPDATE') {
        this.cartEntries = event.data.data;
        // Blink efektini tetikle
        this.scrollToBottom();
        this.triggerBlink();
      }
    };
  },

  beforeDestroy() {
    if (this.broadcaster) {
      this.broadcaster.close();
    }
  },

  methods: {
    async openOtherScreen() {
      var screenResult = (await getScreenDetails());

    console.log(screenResult);
    document.body.requestFullscreen({screen:screenResult.screens.find(screen => !screen.isPrimary)});
    },
    returnSelectedExtraVariant(extra) {
        let returnObj = [];
        let selectedVariants = extra.variants.filter(x => {
          if (x.quantity > 0) {
            returnObj.push("x" + x.quantity + " | " + x.name)
          }
        });
        return returnObj.length > 0 ? returnObj : null;
      },
      triggerBlink() {
      this.shouldBlink = true;
      setTimeout(() => {
        this.shouldBlink = false;
      }, 200); // 200ms sonra efekti kaldır
    },
    scrollToBottom() {
      setTimeout(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth'
        });
      }, 100); // Küçük bir gecikme ekleyerek DOM'un güncellenmesini bekleyin
    }
  }
}
</script>

<style scoped>
.customer-screen {
  padding: 20px;
  background-color: white;
  min-height: 100vh;
  /* Scroll bar'ı gizle */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Webkit tarayıcılar (Chrome, Safari) için scroll bar'ı gizle */
.customer-screen::-webkit-scrollbar {
  display: none;
}

/* Tüm sayfadaki scroll bar'ı gizle */
body {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

body::-webkit-scrollbar {
  display: none;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.blink-animation {
  animation: blink 0.2s ease-in-out;
}

#basket-actions {
  position: sticky;
  left: 0;
  bottom: 0;
  z-index: 999;
  background-color: white;
  height: auto;
  border-top: 0.1rem dotted #000000;
  top: 100%;
}

.price {
  font-weight: 600 !important;
  font-style: italic;
  font-size: 1.75rem !important;
  color: #543633 !important;
  line-height: 1.75rem !important;
}

.label {
  font-size: 1.3vw;
  font-weight: 500 !important;
  line-height: 1.1vw !important;
}
</style>
<style>
/* Global stil - scoped değil */
* {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE and Edge */
}

*::-webkit-scrollbar {
  display: none !important; /* Chrome, Safari and Opera */
  width: 0 !important;
}

html, body {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
}

.vs-table {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.vs-table::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
}
</style>
